/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_UnlockedInputs */

const en_vault_unlocked = /** @type {(inputs: Vault_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault Unlocked ·`)
};

const es_vault_unlocked = /** @type {(inputs: Vault_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bóveda desbloqueada ·`)
};

const fr_vault_unlocked = /** @type {(inputs: Vault_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coffre-fort déverrouillé ·`)
};

const de_vault_unlocked = /** @type {(inputs: Vault_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault entsperrt ·`)
};

const ja_vault_unlocked = /** @type {(inputs: Vault_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保管庫のロックが解除されました ·`)
};

const zh_vault_unlocked = /** @type {(inputs: Vault_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金库已解锁 ·`)
};

const ar_vault_unlocked = /** @type {(inputs: Vault_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم فتح الخزنة ·`)
};

const id_vault_unlocked = /** @type {(inputs: Vault_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault Terbuka ·`)
};

const it_vault_unlocked = /** @type {(inputs: Vault_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault Sbloccato ·`)
};

const ru_vault_unlocked = /** @type {(inputs: Vault_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хранилище открыто ·`)
};

const pt_vault_unlocked = /** @type {(inputs: Vault_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cofre Desbloqueado ·`)
};

const ko_vault_unlocked = /** @type {(inputs: Vault_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보관소(Vault) 잠금 해제됨 ·`)
};

/**
* | output |
* | --- |
* | "Vault Unlocked ·" |
*
* @param {Vault_UnlockedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_unlocked = /** @type {((inputs?: Vault_UnlockedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_UnlockedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_unlocked(inputs)
	if (locale === "es") return es_vault_unlocked(inputs)
	if (locale === "fr") return fr_vault_unlocked(inputs)
	if (locale === "de") return de_vault_unlocked(inputs)
	if (locale === "ja") return ja_vault_unlocked(inputs)
	if (locale === "zh") return zh_vault_unlocked(inputs)
	if (locale === "ar") return ar_vault_unlocked(inputs)
	if (locale === "id") return id_vault_unlocked(inputs)
	if (locale === "it") return it_vault_unlocked(inputs)
	if (locale === "ru") return ru_vault_unlocked(inputs)
	if (locale === "pt") return pt_vault_unlocked(inputs)
	return ko_vault_unlocked(inputs)
});